import api from "./api";
import types from "./types";
import { request } from "api/apiSaga";
import { snackbarShow } from "app/App/actions";
import trans from "helpers/trans";
import { call, put, takeLatest } from "redux-saga/effects";
import { AnyAction } from "redux";
import { downloadFromRequest } from "helpers/download";

function* destroy(action: AnyAction): any {
    const response = yield call(request, api.destroy, action, "delete");

    if (response.status === 204) {
        yield put(
            snackbarShow({
                content: trans("inv.inventoryReport.saga.content.destroy"),
            })
        );
    }
}

function* fetch(action: AnyAction) {
    yield call(request, api.fetch, action);
}

function* get(action: AnyAction) {
    yield call(request, api.get, action);
}

function* reportDownload(action: AnyAction): any {
    const response = yield call(request, api.reports.download, action, "get");
    if (response.status === 200) {
        downloadFromRequest(response);
    }
}

function* store(action: AnyAction): any {
    const response = yield call(request, api.store, action, "post");

    if (response.status === 201) {
        yield put(
            snackbarShow({
                content: trans("inv.inventoryReport.saga.content.store"),
            })
        );
    }
}

function* update(action: AnyAction): any {
    const response = yield call(request, api.update, action, "put");

    if (response.status === 202) {
        yield put(
            snackbarShow({
                content: trans("inv.inventoryReport.saga.content.update"),
            })
        );
    }
}


function* reopen(action: AnyAction): any {
    const response = yield call(request, api.reopen, action, "put");
    if (response.status === 204) {
        yield put(
            snackbarShow({
                content: trans("inv.inventoryReport.saga.content.reopen"),
            })
        );
    } else {
        yield put(
            snackbarShow({
                content: response.data.message,
                severity: "error",
            })
        );
    }
}

export default function* saga() {
    yield takeLatest(types.DESTROY_REQUEST, destroy);
    yield takeLatest(types.FETCH_REQUEST, fetch);
    yield takeLatest(types.GET_REQUEST, get);
    yield takeLatest(types.REOPEN_REQUEST, reopen);
    yield takeLatest(types.REPORT_DOWNLOAD_REQUEST, reportDownload);
    yield takeLatest(types.STORE_REQUEST, store);
    yield takeLatest(types.UPDATE_REQUEST, update);
}
